export const MAX_WIDTH = 480; // px
export const WINDOW_PADDING = 15; // px
export const CANVAS_BORDER = 2;
export const HEADER_HEIGHT = 60;
export const getActiveColor = (val, current) => (
  current === val ? '#ffb6b6' : '#fff'
);
